// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_lOuEx clearfix","box_r":"index_box_r_tLukX","d_box":"index_d_box_ADQXp"};